export const puppetInterviewFirebaseConfig = {
    apiKey: 'AIzaSyDiENYWeWnlW7EVuXSU3eOSH3tzAp2i0EY',
    authDomain: 'puppet-interview.firebaseapp.com',
    databaseURL: 'https://puppet-interview.firebaseio.com',
    projectId: 'puppet-interview',
    storageBucket: 'puppet-interview.appspot.com',
    messagingSenderId: '455010873098',
    appId: '1:455010873098:web:9574905a15a340e4',
};
